import { NavLink } from "react-router-dom";
import instituto1 from '../../assets/img/llamado1.png';
import instituto2 from '../../assets/img/llamado2.png';
import instituto3 from '../../assets/img/llamado3.png';

export const Home = () => {
  return (
    <div className="bg-light">
      {/* --- CARRUSEL DINÁMICO --- */}
      <div id="myCarousel" className="carousel slide carousel-fade shadow" data-bs-ride="carousel">
        <div className="carousel-indicators">
          <button type="button" data-bs-target="#myCarousel" data-bs-slide-to="0" className="active"></button>
          <button type="button" data-bs-target="#myCarousel" data-bs-slide-to="1"></button>
          <button type="button" data-bs-target="#myCarousel" data-bs-slide-to="2"></button>
        </div>
        <div className="carousel-inner">
          <div className="carousel-item active" style={{ height: '550px' }}>
            <div className="overlay-gradient"></div>
            <img src={instituto1} className="d-block w-100 h-100 object-fit-cover" alt="Instituto 1" />
            <div className="carousel-caption mb-5">
              <h1 className="display-3 fw-bold animate__animated animate__fadeInUp">Presbiterio de Guanajuato</h1>
              <p className="lead">Testimonio vivo de la obra de Dios desde 1926.</p>
            </div>
          </div>
          <div className="carousel-item" style={{ height: '550px' }}>
            <div className="overlay-gradient"></div>
            <img src={instituto2} className="d-block w-100 h-100 object-fit-cover" alt="Instituto 2" />
            <div className="carousel-caption mb-5">
              <h1 className="display-4 fw-bold">Nuestras Raíces</h1>
              <p className="lead">Creciendo en fe a través de los Institutos Bíblicos.</p>
            </div>
          </div>
          <div className="carousel-item" style={{ height: '550px' }}>
            <div className="overlay-gradient"></div>
            <img src={instituto3} className="d-block w-100 h-100 object-fit-cover" alt="Instituto 3" />
            <div className="carousel-caption mb-5">
              <h1 className="display-4 fw-bold">50 Misiones</h1>
              <p className="lead">Llevando el evangelio a cada rincón del estado.</p>
            </div>
          </div>
        </div>
      </div>

      <div className="container py-5">
        <div className="row justify-content-center">
          <div className="col-lg-10">
            
            {/* --- SECCIÓN INTRODUCCIÓN --- */}
            <header className="text-center mb-5">
              <h2 className="display-5 fw-bold text-primary">Nuestra Identidad</h2>
              <p className="lead text-muted mx-auto" style={{ maxWidth: '700px' }}>
                Parte de la denominación <strong>ICIAR</strong>. 
                Nacidos bajo el liderazgo del Hno. Josué Mejía, hoy seguimos firmes en la sana doctrina.
              </p>
              <hr className="w-25 mx-auto border-primary border-2 opacity-75" />
            </header>

            {/* --- CUERPO DEL RELATO --- */}
            <article className="bg-white p-4 p-md-5 shadow rounded-4 overflow-hidden">
              <div className="row g-5">
                
                {/* Columna de Texto 1 */}
                <div className="col-md-6 border-end-md">
                  <h3 className="h4 text-primary mb-3">Los Comienzos (1944)</h3>
                  <div className="lh-lg text-secondary">
                    <p>
                      Mis recuerdos son a partir de los años <strong>44 al 45</strong>. 
                      Nos congregábamos en hogares de familias pioneras como los Centeno y los Ramírez-Olmos. 
                      El Evangelio llegó a Guanajuato en 1939 por el hermano <strong>Isabel Bravo</strong>.
                    </p>
                    
                    {/* Imagen insertada en el texto */}
                    <div className="my-4">
                        <img src={instituto2} className="img-fluid rounded shadow-sm" alt="Instituto Historia" />
                        <p className="text-center small text-muted mt-2 fst-italic">Institutos bíblicos: Semilleros de obreros.</p>
                    </div>

                    <p>
                      En el año 45, sentimos en nuestro corazón comprar un terreno para levantar casa a Jehová. 
                      Era un salón humilde donde la presencia de Dios descendía de una manera hermosa.
                    </p>
                  </div>
                </div>

                {/* Columna de Texto 2 */}
                <div className="col-md-6">
                  <blockquote className="blockquote-custom p-4 mb-4 bg-light border-start border-4 border-primary shadow-sm rounded">
                    <p className="mb-0 italic fw-bold text-dark">"¡Amo a María, pero adoro a Cristo!"</p>
                    <footer className="blockquote-footer mt-1 text-primary">Josué Mejía H. (1945)</footer>
                  </blockquote>

                  <div className="lh-lg text-secondary">
                    <p>
                      Bajo la guía de la hermana <strong>Natalia Medina Estrada</strong>, el Consistorio creció. 
                      Ella organizó institutos breves que nos formaron con un sentimiento profundo para servir al Señor.
                    </p>

                    {/* Otra imagen destacada */}
                    <div className="my-4 text-center">
                        <img src={instituto3} className="img-fluid rounded-circle shadow-sm" style={{ width: '200px', height: '200px', objectFit: 'cover'}} alt="Crecimiento" />
                    </div>

                    <p>
                      Pasamos por persecución; en Cuéramaro quemaron Biblias y bancas, pero Dios guardó a su pueblo. 
                      Hoy el hermano <strong>Gonzalo González</strong> lidera estas 50 misiones con la misma fe.
                    </p>
                  </div>
                </div>
              </div>

              {/* Banner Final */}
              <div className="mt-5 p-4 rounded-3 text-white text-center shadow" 
                   style={{ background: 'linear-gradient(45deg, #0d6efd, #0dcaf0)' }}>
                <h4 className="fw-light">¡No a nosotros, oh Jehová, sino a tu nombre toda la gloria!</h4>
                <p className="mb-0 small opacity-75">Relatado por la Hna. Esther Castro</p>
              </div>
            </article>

          </div>
        </div>
      </div>

      {/* --- ESTILOS --- */}
      <style>{`
        .overlay-gradient {
          position: absolute;
          top: 0; left: 0; width: 100%; height: 100%;
          background: linear-gradient(to top, rgba(0,0,0,0.8) 0%, rgba(0,0,0,0.2) 60%);
          z-index: 1;
        }
        .carousel-caption { z-index: 2; }
        .object-fit-cover { object-fit: cover; }
        .border-end-md { border-right: 1px solid #dee2e6; }
        @media (max-width: 768px) {
          .border-end-md { border-right: none; }
        }
        .blockquote-custom { font-size: 1.1rem; }
      `}</style>
    </div>
  );
};